<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<ngx-extended-pdf-viewer #pdfViewer (pagesLoaded)="pagesLoaded()" [src]="document$ | async"
    [customToolbar]="toolbarTemplate" [showToolbar]="showToolbar" [customThumbnail]="checkboxThumbnail"
    [pageViewMode]="pageViewMode" [(page)]="page" [showUnverifiedSignatures]="true" [(zoom)]="zoom"
    [sidebarVisible]="sidebarVisible" [showSidebarButton]="showSidebarButton" [height]="height"
    (currentZoomFactor)="zoomChanged()" (pageRendered)="pageRendered($event)" (thumbnailDrawn)="onThumbnailDrawn($event)">
</ngx-extended-pdf-viewer>

<!--
        The toolbar and checkbox templates are NOT true angular templates.
        They do not live within the Angular lifecycle.
        They cannot attach a click handler in the traditional way and must use the style of 'onclick'.
        The click handlers MUST also be attached the window object
        See here: https://pdfviewer.net/extended-pdf-viewer/custom-thumbnails
    -->
<ng-template #toolbarTemplate>
    <div id="toolbarViewer" *ngIf="showToolbar">
        <div id="toolbarViewerLeft" class="toolbar-view">
            <pdf-toggle-sidebar *ngIf="showSidebarButton"></pdf-toggle-sidebar>
            <span class="material-icons" onclick="window.onRotatePage()">
                rotate_right
            </span>
        </div>
        <pdf-zoom-toolbar></pdf-zoom-toolbar>
    </div>
</ng-template>

<ng-template #checkboxThumbnail>
    <a class="pdf-viewer-template">
        <div class="thumbnail nova__link" data-qa-id="thumbnailView" data-page-number="PAGE_NUMBER"
            style="border: none; margin-bottom: 35px;">
            <input id="checkbox_PAGE_NUMBER" type="checkbox" class="thumbnail-checkbox"
                onclick="window.updateThumbnailSelection(PAGE_NUMBER)">Page PAGE_NUMBER
            <div class="thumbnailSelectionRing image-container"
                style="width: var(--thumbnail-width); height: var(--thumbnail-height);">
                <div class="thumbnail-text"
                    style="width: WIDTH_OF_RING; height: HEIGHT_OF_RING;margin-bottom: -HEIGHT_OF_RING">
                </div>
                <img class="thumbnailImage" alt="PDF Thumbnail" />
            </div>
        </div>
    </a>
</ng-template>